webpackJsonp([31740773553394],{

/***/ 1543:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Col = function Col(_ref) {
	  var children = _ref.children,
	      classes = _ref.classes,
	      className = _ref.className,
	      style = _ref.style;
	
	  return _react2.default.createElement(
	    "div",
	    { className: (0, _classnames2.default)(classes.root, className), style: style },
	    children
	  );
	};
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  return {
	    root: {
	      flex: "1",
	      alignSelf: "flex-start",
	      margin: "15px",
	      minWidth: "400px"
	    }
	  };
	})(Col);
	module.exports = exports["default"];

/***/ }),

/***/ 1551:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _formik = __webpack_require__(10);
	
	var _yup = __webpack_require__(13);
	
	var Yup = _interopRequireWildcard(_yup);
	
	var _Alert = __webpack_require__(14);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _CheckboxGroup = __webpack_require__(17);
	
	var _CheckboxGroup2 = _interopRequireDefault(_CheckboxGroup);
	
	var _Input = __webpack_require__(9);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _RadioGroup = __webpack_require__(16);
	
	var _RadioGroup2 = _interopRequireDefault(_RadioGroup);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Datetime = __webpack_require__(18);
	
	var _Datetime2 = _interopRequireDefault(_Datetime);
	
	var _moment = __webpack_require__(12);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormBroker = function (_Component) {
	  _inherits(FormBroker, _Component);
	
	  function FormBroker(props) {
	    _classCallCheck(this, FormBroker);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      formState: null
	    };
	    return _this;
	  }
	
	  FormBroker.prototype.render = function render() {
	    var _this2 = this;
	
	    var formState = this.state.formState;
	    var _props = this.props,
	        classes = _props.classes,
	        className = _props.className;
	
	
	    var valid = function valid(current) {
	      return current.day() !== 0 && current.day() !== 6;
	    };
	
	    var renderDay = function renderDay(props, currentDate, selectedDate) {
	      if (currentDate.month() == (0, _moment2.default)().month()) {
	        if (currentDate.date() < (0, _moment2.default)().date()) {
	          if (props.className == "rdtDay") {
	            props.className = "rdtDay rdtDisabled";
	          }
	        }
	      }
	      if (currentDate.month() < (0, _moment2.default)().month()) {
	        props.className = "rdtDay rdtDisabled";
	      }
	
	      return _react2.default.createElement(
	        "td",
	        props,
	        currentDate.date()
	      );
	    };
	
	    if (formState === "success") {
	      return _react2.default.createElement(
	        "div",
	        {
	          style: {
	            maxWidth: "600px",
	            textAlign: "center",
	            margin: "24px auto"
	          }
	        },
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _Typography2.default,
	            { type: "heading3", gutterBottom: true },
	            "Fantastic!"
	          ),
	          _react2.default.createElement(
	            _Typography2.default,
	            { type: "heading5", gutterTop: true },
	            "We\u2019ll reach out to you asap via email or telephone.",
	            _react2.default.createElement("br", null),
	            "You can also speak to a member of our sales team immediately by calling",
	            " ",
	            _react2.default.createElement(
	              "a",
	              { href: "tel:18339781196", className: classes.link },
	              "833.978.1196"
	            ),
	            "."
	          )
	        )
	      );
	    } else if (formState === "error") {
	      return _react2.default.createElement(
	        "div",
	        { style: { maxWidth: "400px", margin: "24px auto" } },
	        _react2.default.createElement(
	          _Alert2.default,
	          { color: "error" },
	          "An error occurred."
	        )
	      );
	    }
	
	    return _react2.default.createElement(
	      "div",
	      { className: (0, _classnames2.default)(classes.root, className) },
	      _react2.default.createElement(_formik.Formik, {
	        initialValues: {
	          firstname: "",
	          lastname: "",
	          company: "",
	          email: "",
	          phone: "",
	          mls_number: "",
	          form: "boss_form",
	          list: 85576,
	          meetingdate: "",
	          meetingtime: ""
	        },
	        validationSchema: function validationSchema() {
	          return Yup.object().shape({
	            firstname: Yup.string().required("First name is required"),
	            lastname: Yup.string().required("Last name is required"),
	            company: Yup.string(),
	            email: Yup.string().email("Invalid email address").required("Email is required"),
	            phone: Yup.string().required("Phone is required"),
	            mls_number: Yup.string()
	          });
	        },
	        onSubmit: function onSubmit(values, _ref) {
	          var setSubmitting = _ref.setSubmitting;
	
	          //if (values.meetingdate != undefined) {
	          var meeting_request = "";
	          Object.keys(values).forEach(function (key, index) {
	            // key: the name of the object key
	            // index: the ordinal position of the key within the object
	            if (key == "meetingdate") {
	              if (typeof values.meetingdate.format === "function") {
	                meeting_request = values.meetingdate.format("YYYY-MM-DD") + "T" + values.meetingtime.replace(" (EDT)", "") + "-04:00";
	              }
	            }
	          });
	          var body = _extends({}, values, {
	            utm_campaign: window.utm_tags ? window.utm_tags.campaign : "",
	            utm_source: window.utm_tags ? window.utm_tags.source : "",
	            utm_medium: window.utm_tags ? window.utm_tags.medium : "",
	            utm_term: window.utm_tags ? window.utm_tags.term : "",
	            demo_request_date: meeting_request
	          });
	          return fetch("https://hooks.zapier.com/hooks/catch/4496703/3uy9gh0/", {
	            method: "POST",
	            body: JSON.stringify(body)
	          }).then(function (response) {
	            return response.json();
	          }).then(function (res) {
	            if (res.status === "success") {
	              _this2.setState({ formState: "success" });
	              dataLayer.push({ event: "form-success" });
	
	              if (window.fbq) {
	                window.fbq("track", "Lead");
	              }
	              if (window.gtag) {
	                window.gtag("event", "conversion", {
	                  send_to: "AW-980447970/2_aHCOnsjo8BEOLlwdMD"
	                });
	              }
	              if (window.ga) {
	                window.ga("send", "event", "form", "form_completed", "broker");
	              }
	            } else {
	              _this2.setState({ formState: "error" });
	            }
	          }).catch(function (err) {
	            _this2.setState({ formState: "error" });
	          });
	        },
	        render: function render(_ref2) {
	          var values = _ref2.values,
	              isSubmitting = _ref2.isSubmitting,
	              handleBlur = _ref2.handleBlur,
	              handleChange = _ref2.handleChange;
	          return _react2.default.createElement(
	            _formik.Form,
	            { noValidate: true },
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  maxWidth: "600px",
	                  marginLeft: "auto",
	                  marginRight: "auto"
	                }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: classes.topRow },
	                _react2.default.createElement(_formik.Field, {
	                  id: "firstname",
	                  name: "firstname",
	                  placeholder: "First Name",
	                  component: _Input2.default,
	                  className: classes.field
	                }),
	                _react2.default.createElement(_formik.Field, {
	                  id: "lastname",
	                  name: "lastname",
	                  placeholder: "Last Name",
	                  component: _Input2.default,
	                  className: classes.field
	                })
	              ),
	              _react2.default.createElement(_formik.Field, {
	                id: "email",
	                name: "email",
	                placeholder: "Email",
	                component: _Input2.default,
	                className: classes.field
	              }),
	              _react2.default.createElement(_formik.Field, {
	                id: "phone",
	                name: "phone",
	                placeholder: "Phone",
	                component: _Input2.default,
	                className: classes.field,
	                type: "tel"
	              }),
	              _react2.default.createElement(_formik.Field, {
	                id: "company",
	                name: "company",
	                placeholder: "Affiliation (optional)",
	                component: _Input2.default,
	                className: classes.field
	              }),
	              _react2.default.createElement(_formik.Field, {
	                id: "mls_number",
	                name: "mls_number",
	                placeholder: "MLS # (optional)",
	                component: _Input2.default,
	                className: classes.field
	              }),
	              _react2.default.createElement(
	                "button",
	                {
	                  type: "submit",
	                  className: classes.signUpBtn,
	                  disabled: isSubmitting,
	                  style: { width: "70%" }
	                },
	                "Please Contact Me"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { fontSize: "11px" } },
	              "By submitting this form, you are requesting to be contacted by a member of the Elevate Sales Team at the details provided via text, email or call (may involve automated or pre-recorded means). You may revoke this consent through any reasonable means.",
	              _react2.default.createElement("br", null),
	              "Existing subscribers seeking support, please visit the",
	              " ",
	              _react2.default.createElement(
	                "a",
	                { href: "https://support.tryelevate.com/s/ " },
	                "Elevate Help Center"
	              ),
	              "."
	            )
	          );
	        }
	      })
	    );
	  };
	
	  return FormBroker;
	}(_react.Component);
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  return {
	    root: {
	      display: "flex",
	      flexDirection: "column",
	      width: "100%",
	      maxWidth: "800px",
	      margin: "0 auto",
	      textAlign: "center"
	    },
	    link: {
	      color: "inherit"
	    },
	    field: {
	      borderRadius: "6px",
	      border: "2px solid #ECECEC",
	      height: "50px",
	      fontWeight: "600"
	    },
	    topRow: {
	      display: "flex",
	      flexDirection: "row",
	      justifyContent: "space-between",
	
	      "& > * + *": {
	        marginLeft: "12px"
	      }
	    },
	    headingSmall: {
	      fontSize: "20px",
	      textTransform: "uppercase",
	      fontWeight: "600",
	      color: "#777777",
	      textAlign: "center",
	      padding: "3px"
	    },
	    headingLarge: {
	      fontSize: "40px",
	      textTransform: "uppercase",
	      fontWeight: "700",
	      color: "#55c3ba",
	      textAlign: "center",
	      padding: "3px"
	    },
	    headingText: {
	      color: "#777777",
	      textAlign: "center",
	      padding: "3px",
	      lineHeight: "1.4em"
	    },
	    checkfield: {
	      width: "20px",
	      height: "20px",
	      position: "relative",
	      top: "4px",
	      marginLeft: "10px"
	    },
	    signUpBtn: {
	      width: "100%",
	      fontSize: "20px",
	      lineHeight: "26px",
	      fontWeight: "600",
	      color: "#FFF",
	      backgroundColor: theme.colors.secondary,
	      borderRadius: "6px",
	      padding: "12px",
	      marginTop: "30px",
	      marginBottom: "30px",
	      textDecoration: "none"
	    },
	    selectfield: {
	      borderRadius: "6px",
	      border: "2px solid #ECECEC",
	      height: "40px"
	    },
	    selectlabel: {
	      width: "100%",
	      color: "#888f96",
	      display: "flex",
	      fontSize: "14px",
	      alignItems: "center",
	      lineHeight: "18px",
	      fontWeight: "700",
	      marginBottom: "4px"
	    }
	  };
	})(FormBroker);
	module.exports = exports["default"];

/***/ }),

/***/ 1607:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Row = function Row(_ref) {
	  var children = _ref.children,
	      classes = _ref.classes,
	      className = _ref.className;
	
	  return _react2.default.createElement(
	    "div",
	    { className: (0, _classnames2.default)(classes.root, className) },
	    children
	  );
	};
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  return {
	    root: {
	      width: "100%",
	      display: "flex",
	      flexDirection: "row",
	      flexWrap: "wrap"
	    }
	  };
	})(Row);
	module.exports = exports["default"];

/***/ }),

/***/ 3054:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/broker_bg.a97b0e09.jpg";

/***/ }),

/***/ 3082:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/elevate_boss_white_logo.54267893.png";

/***/ }),

/***/ 3170:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pdf_screenshot.85f5c628.png";

/***/ }),

/***/ 1660:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _siteConfig = __webpack_require__(7);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	var _Container = __webpack_require__(5);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _SEO = __webpack_require__(6);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _Row = __webpack_require__(1607);
	
	var _Row2 = _interopRequireDefault(_Row);
	
	var _Col = __webpack_require__(1543);
	
	var _Col2 = _interopRequireDefault(_Col);
	
	var _pdf_screenshot = __webpack_require__(3170);
	
	var _pdf_screenshot2 = _interopRequireDefault(_pdf_screenshot);
	
	var _ResponsiveVid = __webpack_require__(21);
	
	var _ResponsiveVid2 = _interopRequireDefault(_ResponsiveVid);
	
	var _broker_bg = __webpack_require__(3054);
	
	var _broker_bg2 = _interopRequireDefault(_broker_bg);
	
	var _elevate_boss_white_logo = __webpack_require__(3082);
	
	var _elevate_boss_white_logo2 = _interopRequireDefault(_elevate_boss_white_logo);
	
	var _FormBroker = __webpack_require__(1551);
	
	var _FormBroker2 = _interopRequireDefault(_FormBroker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Brokers = function Brokers(_ref) {
	    var children = _ref.children,
	        classes = _ref.classes,
	        data = _ref.data,
	        tags = _ref.tags;
	
	    var postNode = {
	        title: "Your Single Source Solution - " + _siteConfig2.default.siteTitle
	    };
	
	    return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	            "div",
	            { className: classes.headBackground },
	            _react2.default.createElement(
	                "div",
	                { style: { textAlign: "center" } },
	                _react2.default.createElement("img", { src: _elevate_boss_white_logo2.default, style: { width: "400px", marginTop: "80px" } }),
	                _react2.default.createElement(
	                    "div",
	                    { style: { fontWeight: "700", color: "#5bbfb7", margin: "10px", fontSize: "30px" } },
	                    "The power of PRODUCTIVITY"
	                )
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: classes.root },
	            _react2.default.createElement(
	                _reactHelmet2.default,
	                null,
	                _react2.default.createElement(
	                    "title",
	                    null,
	                    "Your Single Source Solution - " + _siteConfig2.default.siteTitle
	                )
	            ),
	            _react2.default.createElement(_SEO2.default, { postNode: postNode, pagePath: "broker", customTitle: true }),
	            _react2.default.createElement(
	                _Container2.default,
	                null,
	                _react2.default.createElement(
	                    _Row2.default,
	                    null,
	                    _react2.default.createElement(
	                        _Col2.default,
	                        null,
	                        _react2.default.createElement(
	                            "div",
	                            { style: { textAlign: "center" } },
	                            _react2.default.createElement(
	                                "div",
	                                { style: { textAlign: "center", margin: "30px" } },
	                                _react2.default.createElement(
	                                    "h1",
	                                    { className: classes.heading },
	                                    "Tour the ",
	                                    _react2.default.createElement(
	                                        "span",
	                                        { style: { color: "#f05953" } },
	                                        "BOSS"
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "p",
	                                null,
	                                "Request your personal consultation with our brokerage development team using the form below,",
	                                _react2.default.createElement("br", null),
	                                "or call 833.978.1196 to speak to us today."
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { style: { width: "80%", marginLeft: "auto", marginRight: "auto", marginTop: "20px" } },
	                            _react2.default.createElement(_FormBroker2.default, null)
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _Row2.default,
	                    null,
	                    _react2.default.createElement(
	                        _Col2.default,
	                        null,
	                        _react2.default.createElement("hr", null),
	                        _react2.default.createElement(
	                            "div",
	                            { style: { textAlign: "center", margin: "30px" } },
	                            _react2.default.createElement(
	                                "h1",
	                                { className: classes.heading },
	                                "Be the ",
	                                _react2.default.createElement(
	                                    "span",
	                                    { style: { color: "#f05953" } },
	                                    "BOSS"
	                                ),
	                                " (of Recruiting)"
	                            ),
	                            _react2.default.createElement(
	                                "p",
	                                null,
	                                "Free Download: \"The 27 Most Influential Words that Brokers Should Use When Recruiting\""
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _Row2.default,
	                    null,
	                    _react2.default.createElement(
	                        _Col2.default,
	                        { md: 6, style: { textAlign: "center" } },
	                        _react2.default.createElement("img", { src: _pdf_screenshot2.default, alt: "PDF Screenshot", style: { width: "80%", marginLeft: "auto", marginRight: "auto" } })
	                    ),
	                    _react2.default.createElement(
	                        _Col2.default,
	                        { style: { textAlign: "center" } },
	                        "Created by VP of Brokerage Development and linguistics expert Frank Chimento, this popular guide will introduce you approaching recruitment and retention conversations from a position of persuasion and influence. A \"must-read\" for all brokers.",
	                        _react2.default.createElement(
	                            "div",
	                            { style: { marginTop: "30px", marginBottom: "30px", textAlign: "center" } },
	                            _react2.default.createElement(
	                                "div",
	                                { style: { width: "60%", marginLeft: "auto", marginRight: "auto", marginTop: "40px" } },
	                                _react2.default.createElement(
	                                    "a",
	                                    { href: "/assets/recruiting_influencial_words.pdf", style: {
	                                            color: "#FFF",
	                                            padding: "14px 16px",
	                                            fontSize: "14px",
	                                            fontWeight: "700",
	                                            alignContent: "center",
	                                            borderRadius: "4px",
	                                            letterSpacing: ".25px",
	                                            justifyContent: "center",
	                                            textDecoration: "none",
	                                            backgroundColor: "#55c3ba"
	                                        } },
	                                    "Download Now"
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _Row2.default,
	                    null,
	                    _react2.default.createElement(
	                        _Col2.default,
	                        null,
	                        _react2.default.createElement(
	                            "div",
	                            { style: { textAlign: "center", margin: "30px" } },
	                            _react2.default.createElement(
	                                "h1",
	                                { className: classes.heading },
	                                "Explore ",
	                                _react2.default.createElement(
	                                    "span",
	                                    { style: { color: "#f05953" } },
	                                    "MORE"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "p",
	                                null,
	                                "Looking for more information?  Explore below or call 833.978.1196 to speak to a member",
	                                _react2.default.createElement("br", null),
	                                "of our brokerage development team.  We're here to help."
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	    var _fullWidthVid;
	
	    return {
	        root: {
	            display: "flex",
	            flexDirection: "column",
	            width: "100%",
	            padding: "0 8px",
	            margin: "0px auto",
	            lineHeight: "1.5",
	            color: "#212529"
	        },
	        headBackground: {
	            backgroundImage: "url('" + _broker_bg2.default + "')",
	            backgroundPosition: "bottom",
	            width: "100%",
	            minHeight: "280px"
	        },
	        heading: {
	            fontSize: "40px",
	            fontWeight: "700",
	            letterSpacing: ".14px",
	            color: "#1e1749",
	            textAlign: "center",
	            marginBottom: "12px"
	        },
	        heading2: {
	            fontSize: "28px",
	            fontWeight: "700",
	            letterSpacing: ".14px",
	            color: "#5bbfb7",
	            textAlign: "center",
	            marginBottom: "12px"
	        },
	        subHeading: {
	            fontSize: "18px",
	            lineHeight: "28px",
	            letterSpacing: ".08px",
	            textAlign: "center",
	            margin: "0 auto 36px"
	        },
	        landingHeaderStyle: {
	            textAlign: "center"
	        },
	        fullWidthVid: (_fullWidthVid = {
	            width: "100%",
	            marginLeft: "auto",
	            marginRight: "auto"
	        }, _fullWidthVid[theme.breakpoints[900]] = {
	            width: "75%"
	        }, _fullWidthVid)
	
	    };
	})(Brokers);
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-brokers-js-a77e61940e213e407fb9.js